
import { Component, Input, Output } from '@angular/core'; 
import { NgxPaginationModule } from 'ngx-pagination'; 
import { FormsModule, Validators, NgForm } from '@angular/forms';

import { DebtService } from '../_Services/debt.service';
import { CommonService } from '../_Services/common.service';
import { Router, ActivatedRoute } from '@angular/router'; 

@Component({
  templateUrl: 'receivable.component.html'
})
export class ReceivableComponent {
 
    model: any = {ref: '', ofs: '' };
    debts = [];   
    p: any = 1; 
    ofs = [];

    msg = '';

    paginator = []; 
	constructor(private debtService: DebtService, private commonService: CommonService, private router: Router, private route:ActivatedRoute) { }

    changeShape(ofs){
        console.log(ofs);
        this.model.ofs = ofs;
    }

	pageChanged(page: Number) {
        if(page == undefined) {
            page = 1;
        }
		this.p = page; 
		this.debtService.getReceivables(page, this.model).subscribe(result => {
                 
                this.debts = result.data;
                this.paginator = result.paginator; 
            });  
	}

    deleteDebt(event, debtImportedId) {
        console.log(debtImportedId);
        this.debtService.deleteDebt(debtImportedId).subscribe(result => {
            console.log(result);
                if(result.status === true) {
                    this.msg = 'Debt has been deleted';
                    this.debtService.getReceivables(this.p, null).subscribe(result => {
                         
                        this.debts = result.data;
                        this.paginator = result.paginator; 
                    }); 
                } else {
                    alert('Error');
                }
            }); 
        
    }

	ngOnInit() { 
		 
	    this.debtService.getReceivables(this.p, null).subscribe(result => {
                 
                this.debts = result.data;
                this.paginator = result.paginator; 
            }); 
        // common ofs
        this.commonService.getOfs().subscribe(result => {
                 
                this.ofs = result;
            });  
	}
}


// WEBPACK FOOTER //
// ./src/app/debts/receivable.component.ts